{
  "instances": {
    "auditevents": {
      "audit_log_not_supported_spring_boot_1": "Log de auditoría no soportado para aplicaciones Spring Boot 1.x .",
      "event": "Evento",
      "loading_audit_events": "Cargando Eventos de Auditoría...",
      "no_audit_events_found": "No se encontraron eventos de auditoría.",
      "principal": "Principal",
      "remote_address": "Dirección remota",
      "session_id": "Session Id",
      "timestamp": "Horario",
      "type": "Tipo",
      "label": "Log de Auditoría"
    }
  }
}
